/**
 * Gallery Thumbnail Scroller
 * Observes and scrolls to selected thumbnails in the gallery
 */
(function() {
  // Check if device is mobile
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // Set up event listeners and observers
  ['DOMContentLoaded', 'load'].forEach(event => window.addEventListener(event, initGalleryScroller));
  observeQuickshopModal();
  
  // Initialize gallery scrollers
  function initGalleryScroller() {
    initScrollers(document.querySelectorAll('.gallery-navigation--scroller'));
  }
  
  // Initialize quickshop scrollers
  function initQuickshopScroller(modalElement) {
    if (!modalElement.querySelector('.modal-content .product-gallery--navigation')) return;
    initScrollers(modalElement.querySelectorAll('.gallery-navigation--scroller'));
  }
  
  // Common initialization for scrollers
  function initScrollers(scrollers) {
    if (!scrollers || scrollers.length === 0) return;
    scrollers.forEach(scroller => {
      scrollToSelected(scroller);
      observeSelectionChanges(scroller);
    });
  }
  
  function observeQuickshopModal() {
    
    // Function to check and initialize quickshop gallery
    function checkAndInitQuickshop(node) {
      if (!node || node.nodeType !== 1) return;
      
      // Direct check for quickshop modal
      if (node.classList && node.classList.contains('modal--quickshop-full')) {
        // Check immediately and then again after a delay to catch async content loading
        checkForGalleryInModal(node);
        setTimeout(() => checkForGalleryInModal(node), 500);
        setTimeout(() => checkForGalleryInModal(node), 1000);
      }
      
      // Check for quickshop modal as a child
      if (node.querySelector) {
        const modalElements = node.querySelectorAll('.modal--quickshop-full');
        if (modalElements.length > 0) {
          modalElements.forEach(modal => {
            checkForGalleryInModal(modal);
            setTimeout(() => checkForGalleryInModal(modal), 500);
            setTimeout(() => checkForGalleryInModal(modal), 1000);
          });
        }
      }
    }
    
    // Function to check for gallery navigation in modal and initialize if found
    function checkForGalleryInModal(modalElement) {
      if (!modalElement) return;
      
      // Check if the modal has the product gallery navigation
      const galleryNavigation = modalElement.querySelector('.modal-content .product-gallery--navigation');
      if (galleryNavigation) {
        initQuickshopScroller(modalElement);
      } else {
      }
    }
    
    // Create mutation observer to watch for changes in the DOM
    const bodyObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        // Check if nodes were added
        if (mutation.addedNodes && mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            checkAndInitQuickshop(node);
          });
        }
        
        // Also check the target if it's an element
        if (mutation.target && mutation.target.nodeType === 1) {
          // If the target itself is or contains a quickshop modal
          checkAndInitQuickshop(mutation.target);
          
          // Special case: if this is a modal content being modified
          if (mutation.target.classList && 
              (mutation.target.classList.contains('modal-content') || 
               mutation.target.classList.contains('product-gallery'))) {
            const modalElement = mutation.target.closest('.modal--quickshop-full');
            if (modalElement) {
              checkForGalleryInModal(modalElement);
            }
          }
        }
      });
    });
    
    // Start observing the body for changes
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'data-gallery-selected']
    });
    
    // Check any existing modals
    const existingModals = document.querySelectorAll('.modal--quickshop-full');
    if (existingModals.length > 0) {
      existingModals.forEach(modal => {
        checkForGalleryInModal(modal);
      });
    }
    
  }
  
  function scrollToSelected(scroller) {
    // Find the selected thumbnail
    const selectedThumbnail = scroller.querySelector('[data-gallery-selected="true"]');

    if (!selectedThumbnail) {
      return;
    }
    
    // Get dimensions
    const scrollerRect = scroller.getBoundingClientRect();
    const thumbnailRect = selectedThumbnail.getBoundingClientRect();

    
    // Determine if horizontal or vertical scrolling
    const isHorizontal = scrollerRect.width > scrollerRect.height;
    
    if (isHorizontal) {
      // Calculate horizontal scroll position to align thumbnail at the left
      const thumbnailLeft = thumbnailRect.left - scrollerRect.left;
      
      // Check if scroll button is visible and get its width
      let scrollButtonOffset = 4; // Default offset
     
      const scrollButton = document.querySelector('.gallery-navigation--scroll-button');
      if (scrollButton && window.getComputedStyle(scrollButton).display !== 'none') {
        scrollButtonOffset = 4 + scrollButton.offsetWidth;
      }
      
      const targetScroll = thumbnailLeft - scrollButtonOffset;
      
      // Use different scrolling methods based on device type
      if (isMobile) {
        // Direct property assignment for mobile devices
        scroller.scrollLeft = scroller.scrollLeft + targetScroll;
      } else {
        // scrollTo with instant behavior for desktop
        scroller.scrollTo({
          left: scroller.scrollLeft + targetScroll,
          behavior: 'instant'
        });
      }
    } else {
      // Calculate vertical scroll position to align thumbnail at the top
      const thumbnailTop = thumbnailRect.top - scrollerRect.top;
      const targetScroll = thumbnailTop;
      
      // Use different scrolling methods based on device type
      if (isMobile) {
        // Direct property assignment for mobile devices
        scroller.scrollTop = scroller.scrollTop + targetScroll - 2;
      } else {
        // scrollTo with instant behavior for desktop
        scroller.scrollTo({
          top: scroller.scrollTop + targetScroll - 2,
          behavior: 'instant'
        });
      }
    }
  }
  
  function observeSelectionChanges(scroller) {
    // Create mutation observer
    const observer = new MutationObserver(mutations => {
      // Check if any selection attributes changed
      const selectionChanged = mutations.some(mutation => 
        mutation.type === 'attributes' && 
        mutation.attributeName === 'data-gallery-selected'
      );
      
      // If selection changed, scroll to selected
      if (selectionChanged) {
        setTimeout(() => scrollToSelected(scroller), 50);
      }
    });
    
    // Observe all thumbnails
    const thumbnails = scroller.querySelectorAll('[data-gallery-thumbnail]');
    thumbnails.forEach((thumbnail, index) => {
      observer.observe(thumbnail, {
        attributes: true,
        attributeFilter: ['data-gallery-selected']
      });
    });
    
    // Also observe for new thumbnails
    observer.observe(scroller, { childList: true, subtree: true });
  }
})();
